import { useCallback, useMemo } from 'react'

import { BlockchainActivityType, useBlockchainsQuery } from '@shared/graphql'

import type { BlockchainAbbreviation } from '@shared/graphql'

export const useAceBlockchain = (blockchain?: BlockchainAbbreviation) => {
  // TODO: If needed, we can expose the query's loading and error states in the hook
  const { data } = useBlockchainsQuery({
    variables: {
      input: {
        activityType: BlockchainActivityType.ALL,
        isAceSupported: true,
      },
    },
  })

  const getAceBlockchain = useCallback(
    (chain?: BlockchainAbbreviation) => {
      if (chain == null) return

      return data?.blockchains.find((blockchain) => blockchain.chain === chain)
    },
    [data?.blockchains],
  )

  const aceBlockchain = useMemo(
    () => getAceBlockchain(blockchain),
    [blockchain, getAceBlockchain],
  )

  return {
    isAceBlockchain: aceBlockchain !== undefined,
    aceBlockchain,
    getAceBlockchain,
  }
}
